import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { CalendarDays } from "lucide-react";

import { AcademicYearSelect } from "@/components/AcademicYearSelect";
import { useAcademicYearContextOptional } from "@/features/academics/academicYearContext/AcademicYearContext";

export function WorkspaceAcademicYear() {
  const context = useAcademicYearContextOptional();
  if (!context) return null;
  const years = context.academicYears.filter(
    (year) => context.canSelectPreviousYears || year.isActive,
  );
  const selection = (
    <AcademicYearSelect
      options={years.map((year) => ({
        value: year.id,
        label: year.name,
        isActive: year.isActive,
      }))}
      value={context.selectedAcademicYearId ?? ""}
      onChange={(id) => void context.selectAcademicYear(id)}
      disabled={
        context.isLoadingAcademicYears ||
        context.isSwitchingAcademicYear ||
        !context.activeAcademicYearId ||
        years.length <= 1
      }
      label=""
      labelInline
      className="!py-1 !text-xs"
      title={
        context.canSelectPreviousYears
          ? "Select academic year for viewing"
          : "You can only view the active academic year"
      }
    />
  );
  const status = context.isViewingPreviousYear ? (
    <span className="rounded-md bg-amber-50 px-2 py-1 text-xs text-amber-800 dark:bg-amber-500/10 dark:text-amber-300">
      {context.isReadOnlyMode ? "Read-only" : "Viewing previous year"}
    </span>
  ) : null;
  return (
    <>
      <div className="hidden items-center gap-2 xl:flex">
        {selection}
        {status}
      </div>
      <Popover className="relative xl:hidden">
        <PopoverButton
          className="shell-icon relative"
          aria-label="Academic year"
          title="Academic year"
        >
          <CalendarDays size={16} />
          {context.isViewingPreviousYear && (
            <span className="absolute right-1 top-1 h-1.5 w-1.5 rounded-full bg-amber-500" />
          )}
        </PopoverButton>
        <PopoverPanel
          data-workspace-overlay
          className="shell-popover absolute right-0 z-50 mt-2 w-64 space-y-3 p-4"
        >
          <h2 className="text-xs font-semibold text-slate-900 dark:text-white">
            Academic year
          </h2>
          {selection}
          {status}
        </PopoverPanel>
      </Popover>
    </>
  );
}
